document.addEventListener("DOMContentLoaded", () => {
  let marqueeContainer = document.querySelector(".marquee-container");
  let marqueeRows = document.querySelectorAll(".marquee-row");
  let marqueeAnimeArr = [];
  marqueeRows.forEach((marquee) => {
    let track = marquee.querySelector(".marquee-track");
    let trackIndex = track?.getAttribute("data-index");
    let trackDuration = parseInt(track?.getAttribute("data-duration")) * 1000;
    let trackIdSelector = `#marquee-track-${trackIndex}`;
    // Clone track inner li
    // 获取所有 li 子元素(静态 NodeList)
    let lis = track.querySelectorAll('li');

    // 创建一个文档片段（性能更好）
    let fragment = document.createDocumentFragment();
    // 遍历并克隆每个 li，添加到 fragment 中
    lis.forEach(li => {
      let clone = li.cloneNode(true);
      fragment.appendChild(clone);
    });
    // 追加到 ul 里面
    track.appendChild(fragment);
    track.appendChild(fragment);

    let trackScrollWidth = track?.scrollWidth;
    let isOverflowing = trackScrollWidth > marquee.clientWidth;
    if(isOverflowing) {
      let animation = anime({
        targets: trackIdSelector,
        translateX: [`0px`, `-${trackScrollWidth / 2}px`],
        duration: trackDuration,
        easing: 'linear',
        loop: true
      });
      marqueeAnimeArr.push(animation);
    }
  });
  marqueeContainer.addEventListener('mouseenter', () => {
    marqueeAnimeArr?.forEach((animation) => {
      animation.pause();
    });
  });
  marqueeContainer.addEventListener('mouseleave', () => {
    marqueeAnimeArr?.forEach((animation) => {
      animation.play();
    });
  });

  // 移动端补充
  marqueeContainer.addEventListener('touchstart', () => {
    marqueeAnimeArr?.forEach((animation) => {
      animation.pause();
    });
  });
  marqueeContainer.addEventListener('touchend', () => {
    marqueeAnimeArr?.forEach((animation) => {
      animation.play();
    });
  });
  marqueeContainer.addEventListener('touchcancel', () => {
    marqueeAnimeArr?.forEach((animation) => {
      animation.play();
    });
  });
});